var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ModuleContainer",
    _vm._b(
      {
        scopedSlots: _vm._u([
          {
            key: "btn",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "button-container mouse-coordinates-container",
                    class: {
                      "mouse-coordinates-container-mobile": _vm.isMobile,
                    },
                  },
                  [
                    _c("div", { staticClass: "mouse-coordinates" }, [
                      !_vm.isMobile
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "mouse-coordinates-zoom flex-grow-0 d-flex pr-2",
                            },
                            [
                              _c(
                                "span",
                                { attrs: { title: "Current Zoom" } },
                                [
                                  !_vm.zoomIcon
                                    ? _c("SvgIcon", {
                                        attrs: {
                                          size: 14,
                                          type: "mdi",
                                          path: _vm.path.zoom,
                                        },
                                      })
                                    : _c("i", {
                                        class: [_vm.zoomIcon],
                                        attrs: { title: "Current Zoom" },
                                      }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { "margin-left": "4px" } },
                                [_vm._v(_vm._s(_vm.currentZoom))]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "mouse-coordinates-point" }, [
                        _c("div", {
                          staticClass: "selectable",
                          staticStyle: { "margin-left": "4px" },
                          style: {
                            "min-width":
                              _vm.isDMS && _vm.isCrsDegree ? "220px" : "100px",
                          },
                          domProps: { innerHTML: _vm._s(_vm.currentPoint) },
                        }),
                        _vm.isCrsDegree
                          ? _c(
                              "i",
                              {
                                staticClass: "icon-clickable",
                                staticStyle: { "margin-left": "4px" },
                                attrs: {
                                  title: _vm.isDMS
                                    ? "DMS <=> Latitude, Longitude"
                                    : "Latitude, Longitude <=> DMS",
                                },
                                on: { click: _vm.changeDisplayTypePixelValue },
                              },
                              [
                                _c("SvgIcon", {
                                  attrs: {
                                    size: 14,
                                    type: "mdi",
                                    path: _vm.path.change,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _vm.isMobile
                      ? _c("div", { staticClass: "zoom-coordinates" }, [
                          _c(
                            "span",
                            { attrs: { title: "Current Zoom" } },
                            [
                              !_vm.zoomIcon
                                ? _c("SvgIcon", {
                                    attrs: {
                                      size: 14,
                                      type: "mdi",
                                      path: _vm.path.zoom,
                                    },
                                  })
                                : _c("i", {
                                    class: [_vm.zoomIcon],
                                    attrs: { title: "Current Zoom" },
                                  }),
                            ],
                            1
                          ),
                          _c("div", { staticStyle: { "margin-left": "4px" } }, [
                            _vm._v(_vm._s(_vm.currentZoom)),
                          ]),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "crs-coordinates" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.crs,
                              expression: "crs",
                            },
                          ],
                          staticClass: "crs-select",
                          staticStyle: { width: "70px" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.crs = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        _vm._l(_vm.crsItems, function (item) {
                          return _c(
                            "option",
                            { key: item.epsg, domProps: { value: item.epsg } },
                            [_vm._v(" " + _vm._s(item.name || item.epsg) + " ")]
                          )
                        }),
                        0
                      ),
                    ]),
                    _c("div", { ref: "scale", staticClass: "scale-custom" }),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "ModuleContainer",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }